import type { AppTheme, ClientUserPreferences } from '../types/schema'

export const LIGHT_THEMES: ReadonlySet<AppTheme> = new Set<AppTheme>([
  'MOSAIC_LIGHT',
  'LIGHT',
  'PEARL',
  'LINEN',
  'GLACIER',
  'BLUSH',
  'SAGE',
])

export const isLightTheme = (theme: AppTheme): boolean => LIGHT_THEMES.has(theme)

export const mapToMosaicTheme = (theme: AppTheme): AppTheme => {
  return isLightTheme(theme) ? 'MOSAIC_LIGHT' : 'MOSAIC_DARK'
}

export const applyMosaicMove = (prefs: ClientUserPreferences): ClientUserPreferences => {
  if ((prefs.lookVersion ?? 0) >= 1) {
    return prefs
  }

  return {
    ...prefs,
    theme: mapToMosaicTheme(prefs.theme),
    memberAppTheme: prefs.memberAppTheme !== null && prefs.memberAppTheme !== undefined
      ? mapToMosaicTheme(prefs.memberAppTheme)
      : prefs.memberAppTheme,
    lookVersion: 1,
    mosaicToastPending: true,
  }
}
